import {
  FromStore,
  Job,
  SystemChatRecord,
  UserChatRecord,
  Variation,
} from '@cartwhl/common/types';

export function isUserChatRecord(record: any): record is UserChatRecord {
  return record.type === 'USER';
}

export function isSystemChatRecord(record: any): record is SystemChatRecord {
  return record.type === 'SYSTEM';
}

export function findVariationSet(
  record: FromStore<SystemChatRecord>,
  animationNumber: string,
) {
  return record.animationNumbers?.find((set) => {
    return set.indexOf(Number(animationNumber)) !== -1;
  });
}

export function getLastSystemRecord(job: FromStore<Job>) {
  const pair = job.chatHistory?.at(-1);
  if (!pair) return;
  return pair[1];
}

export function findRecordPairByAnimationNumber(
  animationNumber: string,
  jobData?: FromStore<Job>,
) {
  if (!jobData) return;

  const index = jobData.chatHistory.findIndex((pair) => {
    return (
      pair[1].animationNumbers?.flat().indexOf(Number(animationNumber)) !== -1
    );
  });

  return jobData.chatHistory[index];
}

// Returns all variations of the related motion set
export function getVariationsByAnimationNumber(
  animationNumber: string,
  jobData: FromStore<Job>,
) {
  const pair = findRecordPairByAnimationNumber(animationNumber, jobData);
  if (!pair) return;
  const currentSet = findVariationSet(pair[1], animationNumber);
  return currentSet?.map((n) => jobData.variationInfoByID[n]) || [];
}

export function getReferenceVariation(
  animationNumber?: string,
  jobData?: FromStore<Job>,
): {
  referenceVariation: FromStore<Variation> | undefined;
  referenceChatRecord: FromStore<UserChatRecord> | undefined;
  referenceSystemRecord: FromStore<SystemChatRecord> | undefined;
} {
  if (jobData && animationNumber) {
    const currentPairIndex: number = findPairIndexByAnimationNumber(
      animationNumber,
      jobData.jobID,
      jobData.chatHistory,
    );
    const currentPair = jobData.chatHistory[currentPairIndex];

    const referenceAnimationNumber = currentPair[0].animationNumber ?? -1;
    const referenceJobId = currentPair[0].jobID ?? '';
    const referenceIndex = findPairIndexByAnimationNumber(
      referenceAnimationNumber.toString(),
      referenceJobId,
      jobData.chatHistory,
    );
    if (referenceIndex < currentPairIndex - 1) {
      return {
        referenceVariation: jobData.variationInfoByID[referenceAnimationNumber],
        referenceChatRecord: jobData.chatHistory[referenceIndex][0],
        referenceSystemRecord: jobData.chatHistory[referenceIndex][1],
      };
    }
  }
  return {
    referenceVariation: undefined,
    referenceChatRecord: undefined,
    referenceSystemRecord: undefined,
  };
}

export function findPairIndexByAnimationNumber(
  animationNumber: string,
  jobId: string,
  pairs: FromStore<[UserChatRecord, SystemChatRecord][]>,
) {
  return pairs.findIndex((pair) => {
    return (
      pair[1].jobIDs?.flat().indexOf(jobId) !== -1 &&
      pair[1].animationNumbers?.flat().indexOf(Number(animationNumber)) !== -1
    );
  });
}
